import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging';
import { VendorModel } from './vendor.model';
import { EfaactDataService } from '../efaact.data-service';

export const entityName = 'Vendor';
@Injectable({ providedIn: 'root' })
export class VendorDataService extends EfaactDataService<VendorModel> {
    mapItems(item: VendorModel): VendorModel {
        return {
            ...item,
            id: item.VendorListID
        };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
